<template lang="html">
  <div id="loginPage" class="pageContainer">
    <p class="text-right mx-4 my-3"><router-link :to="{ name: 'Index' }">Back Home</router-link></p>
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-8 col-md-6 col-lg-4 mx-auto">
          <h1 class="text-center">Login</h1>
          <p class="text-danger" v-if="feedback">{{ feedback }}</p>
          <button id="facebookButton" @click.prevent="LogUserInViaFacebook" type="button" name="button" class="btn btn-block btn-primary my-3"><span>Login With Facebook</span><i class="d-none fa fa-spin fa-spinner"></i></button>
          <hr class="my-4">
          <form id="stepOne">
            <div class="form-group">
              <label for="inputEmail">Email address</label>
              <input v-model="email" type="email" class="form-control" id="inputEmail" placeholder="Enter email" autofocus="autofocus">
            </div>
            <div class="form-group">
              <label for="inputPassword">Password</label>
              <input v-model="password" type="password" class="form-control" id="inputPassword" aria-describedby="passwordHelp" placeholder="Password">
              <small id="passwordHelp" class="form-text text-right text-muted"><router-link :to="{ name: 'ForgotPassword' }">Forgot Password?</router-link></small>
            </div>
            <button id="loginButton" @click.prevent="LogUserInViaPassword" type="submit" class="btn btn-primary"><span>Login</span><i class="d-none fa fa-spin fa-spinner"></i></button>
          </form>
          <form id="stepTwo" class="d-none">
            <div class="form-group">
              <label for="inputUsernameFB">Username</label>
              <input type="text" class="form-control" id="inputUsernameFB" v-model="username" placeholder="Username">
            </div>
            <button id="finishButton" @click.prevent="SaveUsername" type="submit" class="btn btn-primary"><span>Finish</span><i class="d-none fa fa-spin fa-spinner"></i></button>
          </form>
          <p class="mt-4 text-center">Not a member? <router-link :to="{ name: 'Join' }">Create An Account</router-link></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import db from '@/store/firebaseinit'

export default {
  name: 'Login',
  data() {
    return {
      email: null,
      password: null,
      feedback: null,
      username: null,
      loggedInUserUID: null,
    }
  },
  methods: {
    LogUserInViaFacebook() {
      $('#facebookButton').attr('disabled', true).addClass('disabled')
      $('#facebookButton span').addClass('d-none')
      $('#facebookButton i').removeClass('d-none')
      this.feedback = null
      var provider = new firebase.auth.FacebookAuthProvider();
      provider.addScope('user_birthday');
      firebase.auth().signInWithPopup(provider)
      .then(result => {
        this.loggedInUserUID = result.user.uid
        if(result.additionalUserInfo.isNewUser) {
          // User is new
          db.collection('users').doc(result.user.uid).set({
            first: result.additionalUserInfo.profile.first_name,
            last: result.additionalUserInfo.profile.last_name,
            birthday: result.additionalUserInfo.profile.birthday,
            email: result.user.email,
            photoURL: result.user.photoURL,
            facebookToken: result.credential.accessToken
          }).then(() => {
            firebase.auth().signOut().then(function() {
              $('#facebookButton').addClass('d-none')
              $('#stepOne').addClass('d-none')
              $('#stepTwo').removeClass('d-none')
            }.bind(this)).catch(function(error) {
              $('#facebookButton').attr('disabled', false).removeClass('disabled')
              $('#facebookButton span').removeClass('d-none')
              $('#facebookButton i').addClass('d-none')
              this.feedback = error.message
            })
          }).catch(error => {
            $('#facebookButton').attr('disabled', false).removeClass('disabled')
            $('#facebookButton span').removeClass('d-none')
            $('#facebookButton i').addClass('d-none')
            this.feedback = error.message
          })
        } else {
          db.collection('users').doc(result.user.uid).get()
          .then(result => {
            if(result.data().username) {
              this.$router.push({ name: 'Index' })
            } else {
              firebase.auth().signOut().then(function() {
                $('#facebookButton').addClass('d-none')
                $('#stepOne').addClass('d-none')
                $('#stepTwo').removeClass('d-none')
              }.bind(this)).catch(function(error) {
                $('#facebookButton').attr('disabled', false).removeClass('disabled')
                $('#facebookButton span').removeClass('d-none')
                $('#facebookButton i').addClass('d-none')
                this.feedback = error.message
              })
            }
          }).catch(error => {
            $('#facebookButton').attr('disabled', false).removeClass('disabled')
            $('#facebookButton span').removeClass('d-none')
            $('#facebookButton i').addClass('d-none')
            this.feedback = error.message
          })
        }
      }).catch(error => {
        $('#facebookButton').attr('disabled', false).removeClass('disabled')
        $('#facebookButton span').removeClass('d-none')
        $('#facebookButton i').addClass('d-none')
        this.feedback = error.message
      })
    },
    SaveUsername() {
      $('#stepTwo input').attr('disabled', true).addClass('disabled')
      $('#finishButton').addClass('disabled')
      $('#finishButton span').removeClass('d-none')
      $('#finishButton i').addClass('d-none')

      if(this.username) {
        this.feedback = null
        // check if username is unique
        db.collection('users').where("username", "==", this.username).get()
        .then(result => {
          if(result.empty) {
            // Username is not taken
            db.collection('users').doc(this.loggedInUserUID).update({
              username: this.username
            }).then(() => {
              this.LogUserInViaFacebook()
            }).catch(error => {
              $('#stepTwo input').attr('disabled', false).removeClass('disabled')
              $('#finishButton').removeClass('disabled')
              $('#finishButton span').removeClass('d-none')
              $('#finishButton i').addClass('d-none')
              this.feedback = "There was an issue saving your username"
            })
          } else {
            $('#stepTwo input').attr('disabled', false).removeClass('disabled')
            $('#finishButton').removeClass('disabled')
            $('#finishButton span').removeClass('d-none')
            $('#finishButton i').addClass('d-none')
            this.feedback = "This username is taken"
          }
        })
      } else {
        $('#stepTwo input').attr('disabled', false).removeClass('disabled')
        $('#finishButton').removeClass('disabled')
        $('#finishButton span').removeClass('d-none')
        $('#finishButton i').addClass('d-none')
        this.feedback = "Please create a username with at least two characters"
      }
    },
    LogUserInViaPassword() {
      if(this.email && this.password) {
        $('#stepOne input').addClass('disabled')
        $('#stepOne input').attr("disabled", true)
        $('#loginButton').attr("disabled", true)
        $('#loginButton span').addClass('d-none')
        $('#loginButton i').removeClass('d-none')
        this.feedback = null

        firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        .then(result => {
          db.collection('users').doc(result.user.uid).get()
          .then(result => {
            this.$router.push({ name: 'Index' })
            // this.$router.push({ name: 'Profile', params: { username: result.data().username } })
          }).catch(error => {
            $('#stepOne input').removeClass('disabled')
            $('#stepOne input').attr("disabled", false)
            $('#loginButton').attr("disabled", false)
            $('#loginButton span').removeClass('d-none')
            $('#loginButton i').addClass('d-none')
            this.feedback = error.message
          })
        }).catch(error => {
          $('#stepOne input').removeClass('disabled')
          $('#stepOne input').attr("disabled", false)
          $('#loginButton').attr("disabled", false)
          $('#loginButton span').removeClass('d-none')
          $('#loginButton i').addClass('d-none')
          this.feedback = error.message
          this.password = null
        })
      } else {
        this.feedback = 'Please enter in all fields'
        $('#stepOne input').removeClass('disabled')
        $('#stepOne input').attr("disabled", false)
        $('#loginButton').attr("disabled", false)
        $('#loginButton span').removeClass('d-none')
        $('#loginButton i').addClass('d-none')
      }
    }
  }
}
</script>

<style lang="css">


</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue